import { useQuery } from '@tanstack/react-query';
import api from '../utils/api';

const STALE = 5 * 60 * 1000;

function total(res) {
  if (!res) return undefined;
  const d = res.data ?? res;
  if (typeof d.total === 'number') return d.total;
  if (typeof d.count === 'number') return d.count;
  if (Array.isArray(d)) return d.length;
  return undefined;
}

function useCount(key, url) {
  const { data } = useQuery({
    queryKey: ['nav-badge', key],
    queryFn: () => api.get(url).then(r => r.data),
    staleTime: STALE,
    refetchInterval: STALE,
    retry: false,
  });
  return total(data);
}

export function useNavBadges() {
  const tickets   = useCount('tickets',   '/api/tickets?status=open&per_page=200');
  const payments  = useCount('payments',  '/api/payments?payment_status=pending&limit=200');
  const meters    = useCount('meters',    '/api/meter-readings?status=pending&per_page=200');
  const contracts = useCount('contracts', '/api/contracts?expiring_days=30&per_page=200');
  return { tickets, payments, meters, contracts };
}
